export default __webpack_public_path__ + "static/imda20181stprize2-42c24ffdabc0c770170ebc495a80ebf6.jpg";